import "./Products.scss";
import package1 from "../../assets/products/pack-1.png";
import package2 from "../../assets/products/pack-2.png";
import package3 from "../../assets/products/pack-3.png";
import { Box, Heading, List, ListIcon, ListItem, Text } from "@chakra-ui/react";
import { translation } from "../../utils/translation";
import { CheckIcon } from "@chakra-ui/icons";

function Products(props) {
  const images = [];
  images["package1"] = package1;
  images["package2"] = package2;
  images["package3"] = package3;

  const whichPackage = () => {
    switch (true) {
      case props.totalDays >= 1 && props.totalDays <= 29:
        return "package1";
      case props.totalDays >= 30 && props.totalDays <= 44:
        return "package2";
      case props.totalDays > 44:
        return "package3";
      default:
        return "package3";
    }
  };

  const getImage = (product) => {
    return images[product];
  };

  let packages = window.translations.packages;

  let product = packages[whichPackage()];

  return (
    <Box className="packages-container" textAlign={"center"}>
      <Heading size="xl" textAlign={"center"} mb={6}>
        {translation("general.complete.product.headline")}
      </Heading>

      <Heading as="h4" size="lg" mb={5}>
        {product.heading}
      </Heading>

      <img
        className={"product-image"}
        src={getImage(whichPackage())}
        alt="product img"
      />

      <Heading as="h4" size="md" my={3}>
        {product.subheading}
      </Heading>

      <List spacing={3}>
        <ListItem>
          <ListIcon mb={0.5} as={CheckIcon} color="brand" />
          {translation("general.complete.product.lists.list1")}
        </ListItem>
        <ListItem>
          <ListIcon mb={0.5} as={CheckIcon} color="brand" />
          {translation("general.complete.product.lists.list2")}
        </ListItem>
        <ListItem>
          <ListIcon mb={0.5} as={CheckIcon} color="brand" />
          {translation("general.complete.product.lists.list3")}
        </ListItem>
        <ListItem>
          <ListIcon mb={0.5} as={CheckIcon} color="brand" />
          {translation("general.complete.product.lists.list4")}
        </ListItem>
      </List>
      {/* <Text>{product.description}</Text> */}

      <Box my={6}>
        <Heading as="h3" size="xl">
          {product.price}
        </Heading>
        <Text fontSize="14">
          {translation("general.complete.product.bottlePrice")}
        </Text>
      </Box>

      <Text>{product.totalPrice}</Text>
    </Box>
  );
}

export default Products;
